import CartItem from "./CartItem";
import { TweenMax, Power2, gsap } from "gsap";

export default class Cart {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());

    this.qtyTO = null
    this.cartLoading = false
    this.el_cartLoading = false

    this.initCart();
    this.handleItemQty()
    this.handleItemRemove()
  }
  initCart() {
    const cartBtns = document.querySelectorAll("button.cart, a.cart");
    const backdrop = document.querySelector(".shCart-backdrop");
    const cartWarp = document.querySelector(".shCart");
    const closeBtn = document.querySelector(".shCart--close");
    const body = document.body;

    for (let btn of cartBtns) {
      btn.addEventListener("click", (e) => {
        body.classList.add("noscroll");
        const carIsOpened = cartWarp.getAttribute("aria-expanded");
        if (carIsOpened === "true") {
          backdrop.classList.remove("opened");
          cartWarp.classList.remove("opened");
          cartWarp.setAttribute("aria-expanded", false);
          // body.classList.add("noscroll");
        } else {
          backdrop.classList.add("opened");
          cartWarp.classList.add("opened");
          cartWarp.setAttribute("aria-expanded", true);
        }
      });
      closeBtn.addEventListener("click", (e) => {
        backdrop.classList.remove("opened");
        cartWarp.classList.remove("opened");
        cartWarp.setAttribute("aria-expanded", false);
        body.classList.remove("noscroll");
      });
      backdrop.addEventListener("click", (e) => {
        // console.log("click");
        backdrop.classList.remove("opened");
        cartWarp.classList.remove("opened");
        cartWarp.setAttribute("aria-expanded", false);
        body.classList.remove("noscroll");
      });
    }
  }

  handleCartLoading(status) {
    const cartWarp = document.querySelector(".shCart");
    switch (status) {
      case true:
        this.cartLoading = true
        this.el_cartLoading = document.createElement("div");
        cartWarp.appendChild(this.el_cartLoading)
        gsap.set(this.el_cartLoading, {
          position: 'absolute',
          zIndex: 999,
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: '#fff',
          opacity: 0
        })
        gsap.to(this.el_cartLoading, {
          opacity: .7
        })
        break;
      default:
        this.cartLoading = false
        gsap.to(this.el_cartLoading, {
          opacity: 0,
          onComplete: () => {
            this.el_cartLoading.remove()
          }
        })
        break;
    }
  }

  handleItemQty() {
    document.querySelectorAll(".shCart-content .shCart--itemWrapper .qty-btn").forEach((item, i) => {
      item.addEventListener('click', (e) => {
        const parent = e.target.parentNode
        const cart_item_key = parent.dataset.cart_item_key
        const qty_input = parent.querySelector('[js-qty-input]')
        const type = e.target.classList.contains('qty-minus') ? 'minus' : 'plus'

        switch (type) {
          case 'minus':
            if (parseInt(qty_input.value) > 1) {
              qty_input.value = parseInt(qty_input.value) - 1
            }
            break;
          case 'plus':
            if (parseInt(qty_input.value) < 99) {
              qty_input.value = parseInt(qty_input.value) + 1
            }
            break;

        }

        clearTimeout(this.qtyTO);
        this.qtyTO = setTimeout(() => {
          // console.log(cart_item_key, parseInt(qty_input.value));
          this.updateCartItem('update', cart_item_key, parseInt(qty_input.value));
        }, 1000);
      })
    });

  }

  handleItemRemove() {
    document.querySelectorAll(".shCart-content .shCart--itemWrapper [js-cart-item-remove]").forEach((item, i) => {
      item.addEventListener('click', (e) => {
        const cart_item_key = e.target.dataset.cart_item_key

        this.updateCartItem('remove', cart_item_key, 0);
      })
    });
  }

  updateCartItem(type, cart_item_key, quantity = 0) {
    if (this.cartLoading) {
      return
    }

    this.handleCartLoading(true)

    let fetch_url = ``
    switch (type) {
      case 'update':
        fetch_url = `${root}${lang == 'tc' ? '' : lang}?www_api=1&cmd=updateCartItem`
        break;
      case 'remove':
        fetch_url = `${root}${lang == 'tc' ? '' : lang}?www_api=1&cmd=removeCartItem`
        break;

    }
    let post_data = {
      cart_item_key: cart_item_key,
      quantity: quantity,
    };

    fetch(fetch_url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(post_data),
      })
      .then((response) => response.json())
      .then((response) => {
        this.handleCartLoading(false)
        if (response.code == 200) {
          document.querySelectorAll("cart-count").forEach((item, i) => {
            item.innerHTML = response.cart_count;
          });

          let old_main = document.querySelector(".shCart-content_wrap .shCart-content");

          let new_main = document.createElement("div");
          new_main.innerHTML = response.cart_main.trim();

          old_main.parentNode.replaceChild(new_main.firstChild, old_main);
          this.handleItemQty()
          this.handleItemRemove()
        }
      });
  }

  resize() {
    // console.log("resize from Navigation.js");
  }
}
